import astra from "../assets/images/astra.png";
import breach from "../assets/images/breach.png";
import brimstone from "../assets/images/brimstone.png";
import chamber from "../assets/images/chamber.png";
import cypher from "../assets/images/cypher.png";
import fade from "../assets/images/fade.png";
import jett from "../assets/images/jett.png";
import kayo from "../assets/images/kayo.png";
import killjoy from "../assets/images/killjoy.png";
import neon from "../assets/images/neon.png";
import omen from "../assets/images/omen.png";
import phoenix from "../assets/images/phoenix.png";
import raze from "../assets/images/raze.png";
import reyna from "../assets/images/reyna.png";
import sage from "../assets/images/sage.png";
import skye from "../assets/images/skye.png";
import sova from "../assets/images/sova.png";
import viper from "../assets/images/viper.png";
import yoru from "../assets/images/yoru.png";

export const agents_images = {
  Astra: astra,
  Breach: breach,
  Brimstone: brimstone,
  Chamber: chamber,
  Cypher: cypher,
  Fade: fade,
  Jett: jett,
  "KAY/O": kayo,
  Killjoy: killjoy,
  Neon: neon,
  Omen: omen,
  Phoenix: phoenix,
  Raze: raze,
  Reyna: reyna,
  Sage: sage,
  Skye: skye,
  Sova: sova,
  Viper: viper,
  Yoru: yoru,
};
